import script from "./HrItemLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./HrItemLabel.vue?vue&type=script&setup=true&lang=js"

import "./HrItemLabel.vue?vue&type=style&index=0&id=fd1e60bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd1e60bc"]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel,QItem});
